export var headers = {
	"Project-Id-Version": "Open-Xchange 7",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "2016-06-22 11:59+0000",
	"PO-Revision-Date": "Thu Sep 22 2011 11:38:57 GMT+0200 (CEST)",
	"Last-Translator": "NAME <EMAIL>",
	Language: "en_US",
	"Language-Team": "OX <i18n@open-xchange.com>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bits",
	"Plural-Forms": "nplurals=2; plural=(n!=1);",
	"MIME-Version": "1.0",
	"X-Generator": "Translate Toolkit 1.11.0"
};
export default {
	headers: headers
};
